export default {
  rankOrder: {
    ariaAddOption: '将{label}添加到排名列表',
    ariaMoveUp: '将{label}上移',
    ariaMoveDown: '将{label}下移',
    ariaRemoveOption: '从排名列表中移除{label}',
  },
  coe: {
    ariaDisclaimer: '免责声明',
    ariaQuestion: '问题',
    ariaConversationHistory: '对话历史',
    ariaYourResponse: '您的回答 {number}',
    ariaFollowUpQuestion: '后续问题 {number}',
    ariaResponseInput: '回答输入框',
    ariaRespondingTo: '正在回答',
    ariaSendResponse: '发送回答',
    ariaThinking: '思考中'
  },
  deviceView: {
    toolbar: '预览设备',
    mobile: '手机',
    tablet: '平板电脑',
    desktop: '桌面'
  },
  header: {
    customLogoAlt: '徽标',
    defaultLogoAlt: 'QuestDIY 徽标'
  }
}
